import { useCallback } from "react";
import { useRecoilValue } from "recoil";
import { multicall } from '@wagmi/core';
import { config } from '../../config/wagmi';
import TradePoolAbi from '../../utils/TradePoolAbi.json';
import { userSmartAccount } from "../../components/RecoilAtom";

const useEscrowOrderSharesHook = () => {
    const smartAccount = useRecoilValue(userSmartAccount);

    const getEscrowOrderSharesHook = useCallback(
        async (address, optionsIdsInPool) => {
            try {
                const tradePoolContract = {
                    address: address,
                    abi: TradePoolAbi,
                };
                const contracts = optionsIdsInPool.map((choiceIndex) => ({
                    ...tradePoolContract,
                    functionName: 'userVotesInEscrow',
                    args: [choiceIndex, smartAccount],
                }));
                const results = await multicall(config, { contracts });        
                return results.map((result) => {
                    if (result.status === 'success') {
                        return result.result;
                    }
                });
            } catch (error) {
                console.error('Error fetching escrow shares:', error);
                throw error;
            }
        },
        [smartAccount]
    );

    return { getEscrowOrderSharesHook };
};

export default useEscrowOrderSharesHook;
